<template>
  <div
    v-if="hasSubitems"
    class="navbar-item has-dropdown is-hoverable"
  >
    <a class="navbar-link">
      <HfIcon
        icon="trophy"
        size="is-small"
      />
      <span class="is-hidden-tablet-only">
        {{ item.text }}
      </span>
    </a>
    <div class="navbar-dropdown">
      <router-link
        v-for="subitem in item.subitems"
        :key="subitem.target"
        :to="target(item, subitem)"
        class="navbar-item"
      >
        <span
          :id="itemId(subitem)"
          @click="navigate"
        >{{ subitem.text }}</span>
      </router-link>
    </div>
  </div>
  <router-link
    v-else
    :to="target(item)"
    class="navbar-item"
  >
    <HfIcon
      v-if="item.icon"
      :icon="item.icon"
      :pack="item.iconPack"
      size="is-small"
    />
    <span
      :id="itemId(item)"
      class="hf-full-padding is-hidden-tablet-only"
      @click="navigate"
    >{{ item.text }}</span>
  </router-link>
</template>


<script setup lang="ts">
  import {computed} from 'vue';
  import {NavigationItem} from '@/model/site/navigation.model';
  import HfIcon from '@/components/ui/HfIcon.vue';

  /**
   * Supports one nesting level only.
   */
  const props = defineProps<{
    item: NavigationItem;
  }>();

  const emit = defineEmits<{
    'navigate-to': [item: NavigationItem];
  }>();

  const hasSubitems = computed(() => !!props.item.subitems && props.item.subitems.length > 0);

  function target(item: NavigationItem, subItem?: NavigationItem): string {
    const targets = ['', item.target];
    if (subItem) {
      targets.push(subItem.target);
    }
    return targets.join('/');
  }

  function navigate(): void {
    emit('navigate-to', props.item);
  }

  function itemId(item: NavigationItem): string {
    // used in (mobile-)navigation.test.js
    return `nav-${item.id}`;
  }
</script>

<style scoped lang="scss">
  @import '../../../assets/styles/variables';

  .has-icons .icon {
    padding-left: 0.4em;
    padding-right: 1.2em;
  }

  .hf-full-padding {
    // die ganze Zeile clickbar machen -> geht das auch anders
    /*padding-right: 100vh;*/
  }
</style>